// extracted by mini-css-extract-plugin
export default {"matchAllTerms":"MatchAllTerms_matchAllTerms__geBFx"};